import { Linking } from 'react-native';
import {
  ANDROID_APP_PLAY_STORE_URL,
  IOS_APP_STORE_URL,
} from 'shared/constants/appStore';
import { isIOS, isIOSBrowser, isWebMac } from 'shared/constants/platform';

const openLink = async (url: string) => {
  const supported = await Linking.canOpenURL(url);
  if (supported) {
    void Linking.openURL(url);
  }
};

export const downloadVaroApp = async () => {
  let appLink = ANDROID_APP_PLAY_STORE_URL;
  if (isIOS || isWebMac || isIOSBrowser) {
    appLink = IOS_APP_STORE_URL;
  }
  await openLink(appLink);
};
